import Schema from "@/store/modules/rotationDays/schema";
import BaseActions from '@/store/base/actions'
import MultipleFormActions from '@/store/base/multipleFormData/actions'

const module = 'rotationDays'

export default BaseActions({module, indexed: true}, {
  //
}, [MultipleFormActions(module), Schema])